import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ActionComponent } from './ActionComponent';
// eslint-disable-next-line import/no-cycle
import { Context } from './ContextWrapper';
import * as action from '../Store/SystemMasters.action';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';

function CardItem({ index, item: cardDetails }) {
  const { _id, name, isActive } = cardDetails;
  const { updateArray, removeFromArray, formState, setFormValues, MasterAddEditAccess, MasterDeleteAccess } = useContext(Context);
  const {
    UserDetails: { userInfo },
  } = useSelector((state) => state);
  const genId = _id || `_id${index}`;

  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [shouldShowDelete, setShouldShowDelete] = useState(true);
  const [shouldShowConfirmation, setShouldShowConfirmation] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!Object.keys(formState?.values)?.includes(_id)) {
      setFormValues(name, _id);
    }
  }, [_id, name, formState]);

  useEffect(() => {
    if (genId.includes('_id')) {
      setShouldShowDelete(false);
      setShouldShowConfirmation(false);
    } else {
      setShouldShowConfirmation(true);
      setShouldShowDelete(true);
    }
  }, [genId]);

  const handleBlur = (e) => {
    const { value } = e.target;
    updateArray({ name: value }, genId);
  };

  const handleDelete = useCallback(async () => {
    try {
      if (genId?.includes('_id')) {
        removeFromArray(genId);
        setFormValues('', genId);
        return null;
      }
      const obj = {
        loggedInUserId: userInfo.userId,
        csId: genId,
      };
      setIsLoading(true);
      await dispatch(action.deleteCostingStageListItem(obj, t));
      await dispatch(action.getCostingStageList({ loggedInUserId: userInfo.userId }));
      setIsLoading(false);
      setShowDelete((prev) => !prev);
    } catch (error) {}
  }, [dispatch, genId, removeFromArray, setFormValues, t, userInfo.userId]);

  const handleActiveInactive = useCallback(async () => {
    try {
      if (genId?.includes('_id')) {
        return null;
      }
      const obj = {
        ...cardDetails,
        isActive: !isActive,
        title: t('CARD_ITEM.COSTING_STAGE'),
        loggedInUserId: userInfo.userId,
      };
      setIsLoading(true);
      await dispatch(action.setActiveInactive(obj, t));
      await dispatch(action.getCostingStageList({ loggedInUserId: userInfo.userId }));
      setIsLoading(false);
      setShowConfirmation((prev) => !prev);
    } catch (error) {}
  }, [cardDetails, dispatch, genId, isActive, t, userInfo.userId]);

  const deleteAction = shouldShowDelete ? () => setShowDelete((prev) => !prev) : handleDelete;
  const activeAction = () => setShowConfirmation((prev) => !prev);

  return (
    <>
      <div className="list-container">
        <li>
          <div className="input-container">
            <div className="d-flex">
              <input
                key={index}
                name={genId}
                value={formState.values?.[genId]}
                onChange={(e) => setFormValues(e.target.value.trimStart(), e.target.name)}
                placeholder={t('CARD_ITEM.ENTER_STAGE')}
                type="text"
                disabled={!MasterAddEditAccess}
                onBlur={handleBlur}
              />
            </div>
            {formState.isSubmitted && <p className="text-danger m-0 p-1">{formState.errors?.[genId]}</p>}
          </div>
          <div className="input-action">
            <ActionComponent
              deleteAction={deleteAction}
              activeAction={activeAction}
              showActiveBtn={shouldShowConfirmation}
              isActive={isActive}
              MasterAddEditAccess={MasterAddEditAccess}
              MasterDeleteAccess={MasterDeleteAccess}
            />
          </div>
        </li>
      </div>

      {shouldShowDelete && (
        <ConfirmationPopup
          onOpen={showDelete}
          onConfirm={() => handleDelete()}
          title={t('CARD_ITEM.DELETE_TITLE')}
          message={t('CARD_ITEM.DELETE_MESSAGE')}
          toggle={() => {
            setShowDelete((prev) => !prev);
          }}
          loading={isLoading}
        />
      )}

      <ConfirmationPopup
        onOpen={showConfirmation}
        onConfirm={() => handleActiveInactive()}
        title={t('CARD_ITEM.CONFIRMATION_TITLE')}
        message={t('CARD_ITEM.CONFIRMATION_MESSAGE')}
        toggle={() => {
          setShowConfirmation((prev) => !prev);
        }}
        loading={isLoading}
      />
    </>
  );
}

export default CardItem;
